module.exports = __webpack_public_path__ + "static/media/MengapaAndaPerlukanInsuransatauTakafulolehBankNegaraMalaysia.84db91c1.jpg";